import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MarketCheckbox, MarketRow } from '@market/react';
import { useCheckoutFlow } from 'typescript/context/checkout_flow';
import { useGetOrderSummary } from 'typescript/hooks/use_order_actions_client';
import { usePaymentContext } from 'typescript/context/payment_context';
import { AddressType } from 'typescript/schemas/address_forms/address_fields';
import { addressString } from 'typescript/utilities/order_data';
import styles from 'typescript/apps/checkout_v3/components/payment/billing_address.module.scss';
import { onCheckoutPageClick } from 'typescript/utilities/tracking';
import { CHECKOUT_PAGE_CLICK_EVENTS } from 'typescript/constants/tracking';
import { fetchLocalizedComponent } from 'typescript/utilities/component_localization';

const AddressFields = fetchLocalizedComponent(
  'typescript/apps/checkout_v3/components/address_form/address_fields/address_fields',
);

export const BILLING_ADDRESS_ROW_TEST_ID = 'billing-address-row-data-test-id';

const BillingAddress = ({ className = '' }) => {
  const { t } = useTranslation();

  const { orderNumber, trackingData } = useCheckoutFlow();

  const { sameBillingAsShipping, setSameBillingAsShipping } =
    usePaymentContext();

  const { orderSummaryData } = useGetOrderSummary({ orderNumber });

  // this ensures billing address is built from the form values
  useEffect(() => {
    if (orderSummaryData?.bopis_fulfillment_selected) {
      setSameBillingAsShipping(false);
    }
  }, [orderSummaryData?.bopis_fulfillment_selected]);

  return (
    <div className={`shop-grid-container ${className}`}>
      <div className="shop-grid-item-full">
        {orderSummaryData?.bopis_fulfillment_selected ? (
          <h3 className="shop-grid-item-full">
            {t('checkout.summary.address.billingTitle')}
          </h3>
        ) : (
          <MarketRow
            data-testid={BILLING_ADDRESS_ROW_TEST_ID}
            control-position="leading"
            className={styles.billingAddressContainer}
            size="medium"
            selected={sameBillingAsShipping}
            onMarketRowSelected={() => {
              onCheckoutPageClick({
                eventDesc: CHECKOUT_PAGE_CLICK_EVENTS.billing_address_same,
                trackingData,
              });
              setSameBillingAsShipping(true);
            }}
            onMarketRowDeselected={() => {
              onCheckoutPageClick({
                eventDesc: CHECKOUT_PAGE_CLICK_EVENTS.billing_address_different,
                trackingData,
              });
              setSameBillingAsShipping(false);
            }}
          >
            <label slot="label">
              {t('checkout.payment_v3.billingAddress.title')}
            </label>
            <p slot="subtext" className="paragraph-20">
              {addressString(orderSummaryData?.shipping_address)}
            </p>
            <MarketCheckbox slot="control"></MarketCheckbox>
          </MarketRow>
        )}
      </div>
      {!sameBillingAsShipping && (
        <AddressFields addressType={AddressType.billing} />
      )}
    </div>
  );
};

export default BillingAddress;
